/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPageContractViewFragmentDoc } from './SettingsPageContractView.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type ContractType =
  | 'CORPORATE'
  | 'INDIVIDUAL'
  | 'UNKNOWN';

export type PaymentMethod =
  | 'STRIPE'
  | 'UNKNOWN';

export type SettingsPageContractViewFetcherQueryVariables = Exact<{ [key: string]: never; }>;


export type SettingsPageContractViewFetcherQuery = { contract: { invoiceCustomerName: string, email: string, paymentMethod: Types.PaymentMethod, isEditablePeriod: boolean, contractType: Types.ContractType } | null };


export const SettingsPageContractViewFetcherDocument = gql`
    query SettingsPageContractViewFetcher {
  contract {
    ...SettingsPageContractView
  }
}
    ${SettingsPageContractViewFragmentDoc}`;

/**
 * __useSettingsPageContractViewFetcherQuery__
 *
 * To run a query within a Vue component, call `useSettingsPageContractViewFetcherQuery` and pass it any options that fit your needs.
 * When your component renders, `useSettingsPageContractViewFetcherQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useSettingsPageContractViewFetcherQuery();
 */
export function useSettingsPageContractViewFetcherQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageContractViewFetcherQuery, SettingsPageContractViewFetcherQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageContractViewFetcherQuery, SettingsPageContractViewFetcherQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageContractViewFetcherQuery, SettingsPageContractViewFetcherQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<SettingsPageContractViewFetcherQuery, SettingsPageContractViewFetcherQueryVariables>(SettingsPageContractViewFetcherDocument, {}, options);
}
export function useSettingsPageContractViewFetcherLazyQuery(options: VueApolloComposable.UseQueryOptions<SettingsPageContractViewFetcherQuery, SettingsPageContractViewFetcherQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<SettingsPageContractViewFetcherQuery, SettingsPageContractViewFetcherQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<SettingsPageContractViewFetcherQuery, SettingsPageContractViewFetcherQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<SettingsPageContractViewFetcherQuery, SettingsPageContractViewFetcherQueryVariables>(SettingsPageContractViewFetcherDocument, {}, options);
}
export type SettingsPageContractViewFetcherQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<SettingsPageContractViewFetcherQuery, SettingsPageContractViewFetcherQueryVariables>;